module.exports = __webpack_public_path__ + "img/9-2.52538d02.jpg";